import { PageHeader } from "@/components/common/PageHeader";
import { VERTICALS } from "@/lib/content";
import { VerticalSection } from "@/components/sections/VerticalSection";
import { TellUsSection } from "@/components/sections/TellUsSection";
import SEO from "@/components/common/SEO";

export default function Services() {
  return (
    <div data-testid="services-page">
      <SEO
        title="Recruitment, HR & Career Services | Success Crest Consulting"
        description="Success Crest Consulting provides recruitment, candidate sourcing, HR consulting, career support, resume and ATS services, and AI-powered website solutions."
        path="/services"
      />

      <PageHeader
        overline="Our Solutions"
        title="Three fronts. One accountable partner."
        subtitle="Success Crest Consulting works across People & HR, Career, and AI & Digital. Explore each below, or start from your problem and we'll route you."
        tone="navy"
      />

      {VERTICALS.map((v) => (
        <VerticalSection
          key={v.id}
          vertical={v}
          tone={v.id === "career" ? "soft" : "white"}
        />
      ))}

      <TellUsSection />
    </div>
  );
}
